import React, { Component } from 'react';

import { withStyles } from '@mui/styles';

import { Button, Dialog, DialogTitle } from '@mui/material';

import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';

import Node from './Node';
import CommonStyles from './CommonStyles';
import TrplSelect from './TrplControls/TrplSelect';

const styles = {
  ...CommonStyles,
  nodeContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '5px',
    marginBottom: '3px',
  },
};

class TargetAudienceFormula extends Component {
  state = {
    formula: {
      concept: '',
      action: '+',
      cons: [],
      ops: [],
    },
    subsSelectKeys: [],
  };

  componentDidMount = () => {
    this.onDialogEnter();
  };

  onDialogEnter = () => {
    const { subs, subsInterface } = this.props;
    const { formula } = this.state;

    formula.concept = subs.length && subsInterface ? subsInterface : subs[0] && subs[0].id ? subs[0].id : '';
    formula.ops = this.props.formula ? this.props.formula.ops : [];
    formula.cons = this.props.formula ? this.props.formula.cons : [];

    const subsSelectKeys = [];

    subs.forEach(sub =>
    sub.id === subsInterface ?
      subsSelectKeys.unshift({
        value: sub.id,
        title: `All (${sub.title})`,
      }) :
      subsSelectKeys.push({
        value: sub.id,
        title: sub.title,
      })
    );

    this.setState({ formula, subsSelectKeys });
  };

  onConceptsChainSelectChange = (conceptId) => {
    const { formula } = this.state;

    formula.concept = +conceptId;

    this.setState({ formula });
  };

  onActionsChainSelectChange = (value) => {
    const { formula } = this.state;

    formula.action = value;

    this.setState({ formula });
  };

  onAddConceptClick = () => {
    const { formula } = this.state;

    if (!formula.cons.length) {
      formula.cons.push(formula.concept);
    } else {
      formula.cons.push(formula.concept);
      formula.ops.push(formula.action);
    }

    this.setState({ formula });
  };

  onSubRemoveClick = (index) => {
    const { formula } = this.state;

    formula.cons.splice(index, 1);
    formula.ops.splice(index - 1, 1);

    this.setState({ formula });
  };

  render() {
    const { classes, isOpen, onClose, subs, onSaveClick } = this.props;
    const { formula, subsSelectKeys } = this.state;

    return (
      <Dialog open={isOpen} onClose={() => onClose()}>
        <DialogTitle>Target audience formula</DialogTitle>

        <div style={{ padding: '20px' }}>
          <div className={`${classes.mb20} ${classes.alignCenter}`}>
            {formula.cons && formula.cons.length ? (
              <div className={`${classes.mr20} ${classes.alignCenter}`}>
                <div className={`${classes.w200} ${classes.mr10}`}>
                  <TrplSelect
                    margin="none"
                    values={['+', '-']}
                    value={formula.action}
                    onChange={(e) => this.onActionsChainSelectChange(e.target.value)}
                  />
                </div>
              </div>
            ) : null}

            <div className={`${classes.w200} ${classes.mr10}`}>
              <TrplSelect
                margin="none"
                complicatedValues
                value={formula.concept}
                values={subsSelectKeys}
                onChange={(e) => this.onConceptsChainSelectChange(e.target.value)}
              />
            </div>

            <Button size="small" color="primary" variant="contained" onClick={this.onAddConceptClick}>
              Add
            </Button>
          </div>

          <div className={classes.mb20}>
            {formula.cons && formula.cons.length
              ? formula.cons.map((concept, conceptIndex) => {
                  const sub = subs.find((sub) => sub.id === +concept);

                  if (conceptIndex === 0) {
                    if (sub) return (
                      <div key={conceptIndex} className={classes.nodeContainer}>
                        <Node
                          isLink
                          size="sm"
                          node={sub}
                          isRemovable
                          nodeId={sub.id}
                          nodes={subs}
                          onRemoveClick={() => this.onSubRemoveClick(conceptIndex)}
                        />
                      </div>
                    );
                  }

                  if (sub) return (
                    <div className={classes.nodeContainer} key={conceptIndex}>
                      {formula.ops[conceptIndex - 1] === '-' ? (
                        <RemoveOutlinedIcon style={{ fontSize: '14px' }} />
                      ) : (
                        <AddOutlinedIcon style={{ fontSize: '14px' }} />
                      )}

                      <Node
                        isLink
                        size="sm"
                        node={sub}
                        nodes={subs}
                        isRemovable
                        nodeId={sub.id}
                        onRemoveClick={() => this.onSubRemoveClick(conceptIndex)}
                      />
                    </div>
                  );
                })
              : null}
          </div>

          <div className={classes.justifyEnd}>
            <Button size="small" color="primary" variant="contained" onClick={() => onSaveClick(formula)}>
              Save
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default withStyles(styles)(TargetAudienceFormula);
